import Layout from "@/views/Layout.vue";

const router = [
  {
    path: "/solution", //解决方案
    name: "solution",
    component: () => import("@/views/solution/Index.vue"),
  },
  {
    path: "/solution/detail/:id?", //解决方案详情
    name: "solution-detail",
    component: () => import("@/views/solution/Detail.vue"),
  },
];
const routerItem = {
  path: "/",
  redirect: "/solution",
  component: Layout,
  children: router,
};

export default routerItem;
